/* global $ */

const $modules = $.$body.find('[data-module],.module');

// add class to last module
$modules.last().addClass('last-module');

// Accordions
if (document.querySelector('.wp-block-dreamy-accordion')) {
	let timeOutId = null;

	const accordions = document.querySelectorAll(
		'.wp-block-dreamy-accordion'
	);

	accordions.forEach((accordion) => {
		const button = accordion.querySelector('.js-accordion-button');
		const section = accordion.querySelector('.accordion__content');

		// On focus.
		button.addEventListener('focus', () => {
			button.setAttribute('aria-selected', true);
		});
		// On blur.
		button.addEventListener('blur', () => {
			button.setAttribute('aria-selected', false);
		});
		// On click.
		button.addEventListener('click', (e) => {
			e.preventDefault();
			const isExpanded = button.getAttribute('aria-expanded') === 'true';

			button.setAttribute('aria-expanded', ! isExpanded);
			section.setAttribute('aria-hidden', isExpanded);

			if (! isExpanded) {
				timeOutId = setTimeout(() => {
					section.classList.add('js-accordion-fully-open');
				}, 500); // makes sure if the content is really long, it's eventually all opened up
			} else {
				section.classList.remove('js-accordion-fully-open');
				clearTimeout(timeOutId);
			}
		});
	});
}
